import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  Stack,
  Typography,
  formatPercentTotal,
  getSpacing,
  pn,
} from "@compass/core";
import { Input } from "components";
import { PieChart } from "devextreme-react";
import { Connector, Export, Label, Series, Size } from "devextreme-react/pie-chart";
import { AprEtsTabIVD as AprResponseModel, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEtsTabIVD = (props: {
  data: AprResponseModel | undefined;
  totalTabA: number | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {
  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">Post-Secondary Placements</Typography>
        <Grid container spacing="lg">
          <Grid item xs={12}>
            <Grid container spacing="sm" direction="row" >
              <Grid item xs={2}></Grid>
              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography variant="h6" style={{ textAlign: "center" }}>
                  C.1
                </Typography>
              </Grid>
              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography variant="h6" style={{ textAlign: "center" }}>
                  C.2
                </Typography>
              </Grid>
              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography variant="h6" style={{ textAlign: "center" }}>
                  C.1 + C.2
                </Typography>
              </Grid>
              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography variant="h6" style={{ textAlign: "center" }}>
                  C.3
                </Typography>
              </Grid>
              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography variant="h6" style={{ textAlign: "center" }}>
                  C.4
                </Typography>
              </Grid>
              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography variant="h6" style={{ textAlign: "center" }}>
                  C.5
                </Typography>
              </Grid>
              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography variant="h6" style={{ textAlign: "center" }}>
                  C.3 - C.5
                </Typography>
              </Grid>
              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography variant="h6" style={{ textAlign: "center" }}>
                  Total
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          {/* Row 1 */}
          <Grid item xs={12} style={{ paddingTop:"24px", paddingBottom: "24px"}}>
            <Grid container spacing="sm" direction="row">
              <Grid item xs={2}>
                <Typography variant="h6">Public 2-Year Institution</Typography>
              </Grid>

              {props.data?.public2YearCode1 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.public2YearCode1}
                  </Typography>
                </Grid>
              )}

              {props.data?.public2YearCode2 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.public2YearCode2}
                  </Typography>
                </Grid>
              )}

              {props.data?.public2YearCode1 != null && props.data?.public2YearCode2 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.public2YearCode1 + props.data.public2YearCode2}
                  </Typography>
                </Grid>
              )}

              {props.data?.public2YearCode3 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.public2YearCode3}
                  </Typography>
                </Grid>
              )}

              {props.data?.public2YearCode4 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.public2YearCode4}
                  </Typography>
                </Grid>
              )}

              {props.data?.public2YearCode5 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.public2YearCode5}
                  </Typography>
                </Grid>
              )}

              {props.data?.public2YearCode3 != null &&
                props.data?.public2YearCode4 != null &&
                props.data?.public2YearCode5 != null && (
                  <Grid item xs={1} style={{ alignContent: "center" }}>
                    <Typography style={{ textAlign: "center" }} variant="body1">
                      {props.data.public2YearCode3 + props.data.public2YearCode4 + props.data.public2YearCode5}
                    </Typography>
                  </Grid>
                )}

              {props.data?.public2YearCode1 != null &&
                props.data?.public2YearCode2 != null &&
                props.data?.public2YearCode3 != null &&
                props.data?.public2YearCode4 != null &&
                props.data?.public2YearCode5 != null && (
                  <Grid item xs={1} style={{ alignContent: "center" }}>
                    <Typography style={{ textAlign: "center" }} variant="body1">
                      {props.data.public2YearCode1 +
                        props.data.public2YearCode2 +
                        props.data.public2YearCode3 +
                        props.data.public2YearCode4 +
                        props.data.public2YearCode5}
                    </Typography>
                  </Grid>
                )}
            </Grid>
          </Grid>

          {/* Row 2 */}
          <Grid item xs={12} style={{ background: "#f5f5f5", paddingTop:"24px", paddingBottom: "24px" }}>
            <Grid container spacing="sm" direction="row">
              <Grid item xs={2}>
                <Typography variant="h6">Private 2-Year Institution</Typography>
              </Grid>

              {props.data?.private2YearCode1 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.private2YearCode1}
                  </Typography>
                </Grid>
              )}

              {props.data?.private2YearCode2 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.private2YearCode2}
                  </Typography>
                </Grid>
              )}

              {props.data?.private2YearCode1 != null && props.data?.private2YearCode2 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.private2YearCode1 + props.data.private2YearCode2}
                  </Typography>
                </Grid>
              )}

              {props.data?.private2YearCode3 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.private2YearCode3}
                  </Typography>
                </Grid>
              )}

              {props.data?.private2YearCode4 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.private2YearCode4}
                  </Typography>
                </Grid>
              )}

              {props.data?.private2YearCode5 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.private2YearCode5}
                  </Typography>
                </Grid>
              )}

              {props.data?.private2YearCode3 != null &&
                props.data?.private2YearCode4 != null &&
                props.data?.private2YearCode5 != null && (
                  <Grid item xs={1} style={{ alignContent: "center" }}>
                    <Typography style={{ textAlign: "center" }} variant="body1">
                      {props.data.private2YearCode3 + props.data.private2YearCode4 + props.data.private2YearCode5}
                    </Typography>
                  </Grid>
                )}

              {props.data?.private2YearCode1 != null &&
                props.data?.private2YearCode2 != null &&
                props.data?.private2YearCode3 != null &&
                props.data?.private2YearCode4 != null &&
                props.data?.private2YearCode5 != null && (
                  <Grid item xs={1} style={{ alignContent: "center" }}>
                    <Typography style={{ textAlign: "center" }} variant="body1">
                      {props.data.private2YearCode1 +
                        props.data.private2YearCode2 +
                        props.data.private2YearCode3 +
                        props.data.private2YearCode4 +
                        props.data.private2YearCode5}
                    </Typography>
                  </Grid>
                )}
            </Grid>
          </Grid>

          {/* Row 3 */}
          <Grid item xs={12} style={{ paddingTop:"24px", paddingBottom: "24px"}}>
            <Grid container spacing="sm" direction="row">
              <Grid item xs={2}>
                <Typography variant="h6">Public 4-Year Institution</Typography>
              </Grid>

              {props.data?.public4YearCode1 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.public4YearCode1}
                  </Typography>
                </Grid>
              )}

              {props.data?.public4YearCode2 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.public4YearCode2}
                  </Typography>
                </Grid>
              )}

              {props.data?.public4YearCode1 != null && props.data?.public4YearCode2 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.public4YearCode1 + props.data.public4YearCode2}
                  </Typography>
                </Grid>
              )}

              {props.data?.public4YearCode3 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.public4YearCode3}
                  </Typography>
                </Grid>
              )}

              {props.data?.public4YearCode4 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.public4YearCode4}
                  </Typography>
                </Grid>
              )}

              {props.data?.public4YearCode5 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.public4YearCode5}
                  </Typography>
                </Grid>
              )}

              {props.data?.public4YearCode3 != null &&
                props.data?.public4YearCode4 != null &&
                props.data?.public4YearCode5 != null && (
                  <Grid item xs={1} style={{ alignContent: "center" }}>
                    <Typography style={{ textAlign: "center" }} variant="body1">
                      {props.data.public4YearCode3 + props.data.public4YearCode4 + props.data.public4YearCode5}
                    </Typography>
                  </Grid>
                )}

              {props.data?.public4YearCode1 != null &&
                props.data?.public4YearCode2 != null &&
                props.data?.public4YearCode3 != null &&
                props.data?.public4YearCode4 != null &&
                props.data?.public4YearCode5 != null && (
                  <Grid item xs={1} style={{ alignContent: "center" }}>
                    <Typography style={{ textAlign: "center" }} variant="body1">
                      {props.data.public4YearCode1 +
                        props.data.public4YearCode2 +
                        props.data.public4YearCode3 +
                        props.data.public4YearCode4 +
                        props.data.public4YearCode5}
                    </Typography>
                  </Grid>
                )}
            </Grid>
          </Grid>

          {/* Row 4 */}
          <Grid item xs={12} style={{ background: "#f5f5f5", paddingTop:"24px", paddingBottom: "24px" }}>
            <Grid container spacing="sm" direction="row">
              <Grid item xs={2}>
                <Typography variant="h6">Private 4-Year Institution</Typography>
              </Grid>

              {props.data?.private4YearCode1 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.private4YearCode1}
                  </Typography>
                </Grid>
              )}

              {props.data?.private4YearCode2 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.private4YearCode2}
                  </Typography>
                </Grid>
              )}

              {props.data?.private4YearCode1 != null && props.data?.private4YearCode2 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.private4YearCode1 + props.data.private4YearCode2}
                  </Typography>
                </Grid>
              )}

              {props.data?.private4YearCode3 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.private4YearCode3}
                  </Typography>
                </Grid>
              )}

              {props.data?.private4YearCode4 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.private4YearCode4}
                  </Typography>
                </Grid>
              )}

              {props.data?.private4YearCode5 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.private4YearCode5}
                  </Typography>
                </Grid>
              )}

              {props.data?.private4YearCode3 != null &&
                props.data?.private4YearCode4 != null &&
                props.data?.private4YearCode5 != null && (
                  <Grid item xs={1} style={{ alignContent: "center" }}>
                    <Typography style={{ textAlign: "center" }} variant="body1">
                      {props.data.private4YearCode3 + props.data.private4YearCode4 + props.data.private4YearCode5}
                    </Typography>
                  </Grid>
                )}

              {props.data?.private4YearCode1 != null &&
                props.data?.private4YearCode2 != null &&
                props.data?.private4YearCode3 != null &&
                props.data?.private4YearCode4 != null &&
                props.data?.private4YearCode5 != null && (
                  <Grid item xs={1} style={{ alignContent: "center" }}>
                    <Typography style={{ textAlign: "center" }} variant="body1">
                      {props.data.private4YearCode1 +
                        props.data.private4YearCode2 +
                        props.data.private4YearCode3 +
                        props.data.private4YearCode4 +
                        props.data.private4YearCode5}
                    </Typography>
                  </Grid>
                )}
            </Grid>
          </Grid>

          {/* Row 5 */}
          <Grid item xs={12} style={{ paddingTop:"24px", paddingBottom: "24px"}}>
            <Grid container spacing="sm" direction="row">
              <Grid item xs={2}>
                <Typography variant="h6">Vocational/Trade Institution</Typography>
              </Grid>

              {props.data?.vocationalCode1 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.vocationalCode1}
                  </Typography>
                </Grid>
              )}

              {props.data?.vocationalCode2 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.vocationalCode2}
                  </Typography>
                </Grid>
              )}

              {props.data?.vocationalCode1 != null && props.data?.vocationalCode2 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.vocationalCode1 + props.data.vocationalCode2}
                  </Typography>
                </Grid>
              )}

              {props.data?.vocationalCode3 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.vocationalCode3}
                  </Typography>
                </Grid>
              )}

              {props.data?.vocationalCode4 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.vocationalCode4}
                  </Typography>
                </Grid>
              )}

              {props.data?.vocationalCode5 != null && (
                <Grid item xs={1} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.vocationalCode5}
                  </Typography>
                </Grid>
              )}

              {props.data?.vocationalCode3 != null &&
                props.data?.vocationalCode4 != null &&
                props.data?.vocationalCode5 != null && (
                  <Grid item xs={1} style={{ alignContent: "center" }}>
                    <Typography style={{ textAlign: "center" }} variant="body1">
                      {props.data.vocationalCode3 + props.data.vocationalCode4 + props.data.vocationalCode5}
                    </Typography>
                  </Grid>
                )}

              {props.data?.vocationalCode1 != null &&
                props.data?.vocationalCode2 != null &&
                props.data?.vocationalCode3 != null &&
                props.data?.vocationalCode4 != null &&
                props.data?.vocationalCode5 != null && (
                  <Grid item xs={1} style={{ alignContent: "center" }}>
                    <Typography style={{ textAlign: "center" }} variant="body1">
                      {props.data.vocationalCode1 +
                        props.data.vocationalCode2 +
                        props.data.vocationalCode3 +
                        props.data.vocationalCode4 +
                        props.data.vocationalCode5}
                    </Typography>
                  </Grid>
                )}
            </Grid>
          </Grid>

          {/* Row 6 */}
          <Grid item xs={12} style={{ background: "#f5f5f5", paddingTop:"24px", paddingBottom: "24px" }}>
            <Grid container spacing="sm" direction="row">
              <Grid item xs={2}>
                <Typography variant="h6">Proprietary Shool</Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography style={{ textAlign: "center" }} variant="body1">
                  N/A
                </Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography style={{ textAlign: "center" }} variant="body1">
                  N/A
                </Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography style={{ textAlign: "center" }} variant="body1">
                  N/A
                </Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography style={{ textAlign: "center" }} variant="body1">
                  N/A
                </Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography style={{ textAlign: "center" }} variant="body1">
                  N/A
                </Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography style={{ textAlign: "center" }} variant="body1">
                  N/A
                </Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography style={{ textAlign: "center" }} variant="body1">
                  N/A
                </Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography style={{ textAlign: "center" }} variant="body1">
                  N/A
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          {/* Row 7 */}
          <Grid item xs={12} style={{ paddingTop:"24px", paddingBottom: "24px"}}>
            <Grid container spacing="sm" direction="row">
              <Grid item xs={2}>
                <Typography variant="h6">Unknown</Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography style={{ textAlign: "center" }} variant="body1">
                  N/A
                </Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography style={{ textAlign: "center" }} variant="body1">
                  N/A
                </Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography style={{ textAlign: "center" }} variant="body1">
                  N/A
                </Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography style={{ textAlign: "center" }} variant="body1">
                  N/A
                </Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography style={{ textAlign: "center" }} variant="body1">
                  N/A
                </Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography style={{ textAlign: "center" }} variant="body1">
                  N/A
                </Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography style={{ textAlign: "center" }} variant="body1">
                  N/A
                </Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography style={{ textAlign: "center" }} variant="body1">
                  N/A
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          {/* Row Totals */}
          <Grid item xs={12} style={{ background: "#f5f5f5", paddingTop:"24px", paddingBottom: "24px" }}>
            <Grid container spacing="sm" direction="row">
              <Grid item xs={2}>
                <Typography variant="h6">Totals</Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography style={{ textAlign: "center" }} variant="body1">
                  {props.data?.public2YearCode1! +
                    props.data?.private2YearCode1! +
                    props.data?.public4YearCode1! +
                    props.data?.private4YearCode1! +
                    props.data?.vocationalCode1!}
                </Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography style={{ textAlign: "center" }} variant="body1">
                  {props.data?.public2YearCode2! +
                    props.data?.private2YearCode2! +
                    props.data?.public4YearCode2! +
                    props.data?.private4YearCode2! +
                    props.data?.vocationalCode2!}
                </Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography style={{ textAlign: "center" }} variant="body1">
                  {props.data?.public2YearCode1! +
                    props.data?.private2YearCode1! +
                    props.data?.public4YearCode1! +
                    props.data?.private4YearCode1! +
                    props.data?.vocationalCode1! +
                    props.data?.public2YearCode2! +
                    props.data?.private2YearCode2! +
                    props.data?.public4YearCode2! +
                    props.data?.private4YearCode2! +
                    props.data?.vocationalCode2!}
                </Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography style={{ textAlign: "center" }} variant="body1">
                  {props.data?.public2YearCode3! +
                    props.data?.private2YearCode3! +
                    props.data?.public4YearCode3! +
                    props.data?.private4YearCode3! +
                    props.data?.vocationalCode3!}
                </Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography style={{ textAlign: "center" }} variant="body1">
                  {props.data?.public2YearCode4! +
                    props.data?.private2YearCode4! +
                    props.data?.public4YearCode4! +
                    props.data?.private4YearCode4! +
                    props.data?.vocationalCode4!}
                </Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography style={{ textAlign: "center" }} variant="body1">
                  {props.data?.public2YearCode5! +
                    props.data?.private2YearCode5! +
                    props.data?.public4YearCode5! +
                    props.data?.private4YearCode5! +
                    props.data?.vocationalCode5!}
                </Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography style={{ textAlign: "center" }} variant="body1">
                  {props.data?.public2YearCode3! +
                    props.data?.private2YearCode3! +
                    props.data?.public4YearCode3! +
                    props.data?.private4YearCode3! +
                    props.data?.vocationalCode3! +
                    props.data?.public2YearCode4! +
                    props.data?.private2YearCode4! +
                    props.data?.public4YearCode4! +
                    props.data?.private4YearCode4! +
                    props.data?.vocationalCode4! +
                    props.data?.public2YearCode5! +
                    props.data?.private2YearCode5! +
                    props.data?.public4YearCode5! +
                    props.data?.private4YearCode5! +
                    props.data?.vocationalCode5!}
                </Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography style={{ textAlign: "center" }} variant="body1">
                  {props.data?.public2YearCode1! +
                    props.data?.private2YearCode1! +
                    props.data?.public4YearCode1! +
                    props.data?.private4YearCode1! +
                    props.data?.vocationalCode1! +
                    props.data?.public2YearCode2! +
                    props.data?.private2YearCode2! +
                    props.data?.public4YearCode2! +
                    props.data?.private4YearCode2! +
                    props.data?.vocationalCode2! +
                    props.data?.public2YearCode3! +
                    props.data?.private2YearCode3! +
                    props.data?.public4YearCode3! +
                    props.data?.private4YearCode3! +
                    props.data?.vocationalCode3! +
                    props.data?.public2YearCode4! +
                    props.data?.private2YearCode4! +
                    props.data?.public4YearCode4! +
                    props.data?.private4YearCode4! +
                    props.data?.vocationalCode4! +
                    props.data?.public2YearCode5! +
                    props.data?.private2YearCode5! +
                    props.data?.public4YearCode5! +
                    props.data?.private4YearCode5! +
                    props.data?.vocationalCode5!}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Stack>
    </Card>
  );
};
